import React from 'react'
const langArrow1= ({fill: 'none', stroke: '#d00031', strokeWidth: '2px' })
const Caret = () =>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="1837.957 81.137 11.184 7.006">
            <path id="Path_103" data-name="Path 103" className="lang-arrow-1" style={langArrow1} d="M380.664,80.844l4.885,4.885,4.885-4.885" transform="translate(1458 1)"></path>
            </svg>
    )
}
export default Caret;